import { useEffect, useMemo, useRef, useState } from 'react';
import "../container_v2.css"
import { CustomDialog } from "react-st-modal";
import {
    Box,
    Button,
    ListItemIcon,
    MenuItem,
} from '@mui/material';
import ReenvioCorreo from '../report_email/send_invoice';
import XML from "../../../../imgComponents/xml.png";
import CANCEL_DOCT from "../../../../imgComponents/tache.png";
import tacheCANCEL from "../../../../imgComponents/re-facturar.png";
import PDF from "../../../../imgComponents/pdf.png";
import PDFCANCEL from "../../../../imgComponents/pdfcancel.png";
import XMLCANCEL from "../../../../imgComponents/xmlcancel.png";
import EMAIL from "../../../../imgComponents/correoElectronico.png";
import { status_invoice, download_invoice_get } from '../../../../services/invoices/invoices';
import { MAP_RELATION_INVOICE } from '../../map_relation/map_relation';
import MAPREL from "../../../../imgComponents/iconos/mapa_relaciones.png";
import { base64toBlobxml, base64toBlob } from '../../../../main_components/donwloadfuncion/download';
import CANCEL_INVOICE_METHOD_2 from '../../cancel_invoice/cancel_invoice_method_2';
import { findInObjectDisplayRole } from '../../../../Content/verify_role';
const RENDER_ROW_ACTION_MENU_ITEMS = (props) => {

    const download_dt = async (typedocumentexmlorpdf, id_invoce, fileName_document) => {
        props.setmenssage("Descargando " + typedocumentexmlorpdf);
        props.setmodalGeneral(true);
        props.setmodalT(true);

        try {
            const data = await download_invoice_get(
                typedocumentexmlorpdf,
                fileName_document,
                id_invoce
            );

            var dt = data.data.file;
            console.log(dt)
            var blob;
            if (typedocumentexmlorpdf === "xml") {
                blob = base64toBlobxml(dt);
            } else {
                blob = base64toBlob(dt);
            }
            const blobUrl = URL.createObjectURL(blob);
            const downloadLink = document.createElement("a");
            downloadLink.href = blobUrl;
            let arr = fileName_document.split("/");
            downloadLink.download = arr[4] + `.${typedocumentexmlorpdf}`;
            downloadLink.click();
            props.setmodalGeneral(false);
            props.setmodalT(false);
        } catch (err) {
            alert(err.response.data.errorMessage.es)
            props.setmodalGeneral(false);
            props.setmodalT(false);
        }
    }

    const handle_status = async (id, uuid, cancel) => {
        props.setmenssage("Verificando estado de la factura");
        props.setmodalGeneral(true);
        props.setmodalT(true);
        props.setreconsult(true)
        try {
            var rf_token = await props.refresh_token();
            if (rf_token === true) {
                setTimeout(async () => {
                    try {
                        const dt = await status_invoice(id, uuid);
                        sessionStorage.setItem("faCancel", dt?.data?.cancellation_request_id);
                        props.setreconsult(false)
                        props.setmodalT(false);
                        props.setmodalGeneral(false);
                        props.handle_get_invoice();

                    } catch (err) {
                        alert(JSON.stringify(err.response.data.errorMessage.es));
                        props.setreconsult(false)
                        props.setmodalGeneral(false);
                        props.setmodalT(false);
                    }
                }, 1000);
            } else { }
        } catch (err) {
            console.log(err);
        }
    }
    return (
        <div>

            <MenuItem
                key={"action1"}
                style={{ display: props.row.original.status === "Cancelado" ? "none" : "" }}
                onClick={async () => {
                    props.closeMenu();

                    await CustomDialog(
                        <CANCEL_INVOICE_METHOD_2
                            id={props.row.original?.id}
                            setUpdateData={props?.setUpdateData}
                            serie={props.row.original?.serie}
                            folio={props.row.original?.folio}
                            flag_cancel={props.row.original?.cancel}
                        ></CANCEL_INVOICE_METHOD_2>,
                        {
                            className: "custom-modal-2",
                            title: `Seleccione el motivo por el cual desea cancelar la factura ${props.row.original?.serie}${props.row.original?.folio}`,
                            showCloseIcon: true,
                        }
                    );
                }}
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={CANCEL_DOCT}
                        title="Cancelar"
                        className=""
                    ></img>
                </ListItemIcon>
                Cancelar Factura
            </MenuItem>

            <MenuItem
                key={"action2"}
                style={{ display: findInObjectDisplayRole(["IN:IN1", "IN:IN3"]) }}
                onClick={() => handle_status(props.row.original.id, props.row.original.uuid_sat)}
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={tacheCANCEL}
                        title="REVERIFICAR ESTADO DE LA FACTURA"
                    ></img>
                </ListItemIcon>
                Actualizar Estado
            </MenuItem>
            <MenuItem
                key={"action3"}
                onClick={() => download_dt("xml", props.row.original.id, props.row.original.filename)}
                style={{ display: findInObjectDisplayRole(["IN:IN1", "IN:IN3"]) }}
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={XML}
                        title="Descargar XML"
                        className=""
                    ></img>
                </ListItemIcon>
                Descargar XML
            </MenuItem>
            <MenuItem
                key={"action4"}
                onClick={() => download_dt("pdf", props.row.original.id, props.row.original.filename)}
                style={{ display: findInObjectDisplayRole(["IN:IN1", "IN:IN3"]) }}
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={PDF}
                        title="Descargar PDF"
                        className=""
                    ></img>
                </ListItemIcon>
                Descargar PDF
            </MenuItem>
            <MenuItem
                key={"action5"}
                style={{
                    display:
                        props.row.original.status !== "Cancelado" && !props.row.original.cancel
                            ? "none"
                            : findInObjectDisplayRole(["IN:IN1", "IN:IN3"])
                }}
                onClick={() => download_dt("xml", props.row.original.id, props.row.original.filename_cancel)}
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={XMLCANCEL}
                        className=""
                        title="Descargar XML  "
                    ></img>
                </ListItemIcon>
                Descargar Acuse de cancelación (XML)
            </MenuItem>
            <MenuItem
                key={"action6"}
                onClick={() => download_dt("pdf", props.row.original.id, props.row.original.filename_cancel)}
                style={{
                    display:
                        props.row.original.status !== "Cancelado" && !props.row.original.cancel
                            ? "none"
                            : findInObjectDisplayRole(["IN:IN1", "IN:IN3"])
                }}
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={PDFCANCEL}
                        className=""
                        title="Descargar PDF"
                    ></img>
                </ListItemIcon>
                Descargar Acuse de cancelación (PDF)
            </MenuItem>
            <MenuItem
                key={"action7"}
                style={{ display: findInObjectDisplayRole(["IN:IN1", "IN:IN3"]) }}
                onClick={async () => {
                    props.closeMenu();
                    sessionStorage.setItem("FACTURAMANDAR", props.row.original.uuid_sat);
                    await CustomDialog(
                        <ReenvioCorreo
                            report={false}
                            id={props.row.original.id}
                            uuid={props.row.original.uuid_sat}
                        ></ReenvioCorreo>,
                        {
                            className: "custom-modal",
                            title:
                                'Nota: SEPARA LOS CORREOS ELECTRÓNICOS A TRAVÉS DE UNA "," SI DESEAS ENVIAR MÁS DE UN CORREO ELECTRÓNICO',
                            showCloseIcon: true,
                        }
                    );
                }}
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={EMAIL}
                        className=""
                        title="Envíar"
                    ></img>
                </ListItemIcon>
                Envíar Correo Electrónico
            </MenuItem>

            <MenuItem
                key={"action8"}
                style={{ display: findInObjectDisplayRole(["IN:IN1", "IN:IN3"]) }}
                onClick={async () => {
                    props.closeMenu();
                    await CustomDialog(
                        <MAP_RELATION_INVOICE row={props.row} setmodalT={props.setmodalT}></MAP_RELATION_INVOICE>,
                        {
                            className: "modal-mapa-rel",
                            title: 'Mapa de relaciones',
                            showCloseIcon: true,
                            isCanClose: false,
                        }
                    )
                }
                }
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={MAPREL}
                        className="mapa_icono"
                        title="Mapa de Relaciones"
                    ></img>
                </ListItemIcon>
                Mapa de Relaciones
            </MenuItem>

        </div >
    );
};

export default RENDER_ROW_ACTION_MENU_ITEMS;
